import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WorkOrderCompanyInformationComponent } from './work-order-company-information.component';
import { CtExpansionPanelModule } from '@ctsolution/ct-framework';

@NgModule({
  imports: [
    CommonModule,
    CtExpansionPanelModule
  ],
  declarations: [WorkOrderCompanyInformationComponent],
  exports: [WorkOrderCompanyInformationComponent]
})
export class WorkOrderCompanyInformationModule { }
